export default __webpack_public_path__ + "static/insights-dark-mode-1f12f219612a544f557767a4c1191898.mp4";